import React, { useContext } from 'react'
import { GeneralDashboardStyles } from './Style'
import { BasicDashboard, General, Student } from '.'
import { AbilityContext } from 'components/Permissions/Can'
import './style.css'

const DashboardPage = () => {
    const ability = useContext(AbilityContext)

    return (
        <GeneralDashboardStyles>
            {
                ability.can("manage", "student") ?
                    <Student /> :
                    <BasicDashboard />
            }
        </GeneralDashboardStyles>
    )
}

export default DashboardPage